export enum ContentManagerCopyMoveModeEnum {
    Move,
    Copy,
    MoveAll,
    CopyAll,
    CopySelectedEmails,
    CopyEntireFolderEmails
}